import { TermsOfUse } from "@/components/legal/TermsOfUse";

export const TermsOfUsePage = () => {
  return <TermsOfUse />;
};
